import "./index.css";
import React, { useEffect, useState } from "react";
import AddReview from "./components/AddReview";
import ReviewSearch from "./components/ReviewSearch";
import Reviews from "./components/Reviews";
import { initialData } from "./utils/data";

const getData = () => {
  // const data = localStorage.getItem("books");
  const data = localStorage.getItem("books");
  if (data) {
    return JSON.parse(data);
  } else {
    return [];
  }
};

const App = () => {
  const [books, setBooks] = useState(getData());
  const [searchTerm, setSearchTerm] = useState("");

  const getBook = (value) => {
    console.log(value);
    setBooks([...books, value]);
    console.log("books: ", books);
  };

  const getSearchTerm = (value) => {
    console.log("searchTerm: ", value);
    setSearchTerm(value);
  };

  useEffect(() => {
    localStorage.setItem("books", JSON.stringify(books));
    console.log("books: ", books);
  }, [books]);

  return (
    <>
      <AddReview getBook={getBook} />
      <ReviewSearch getSearchTerm={getSearchTerm} />
      <Reviews
        books={books}
        initialData={initialData}
        searchTerm={searchTerm}
      />
    </>
  );
};

export default App;
